import { render, staticRenderFns } from "./bigImage.vue?vue&type=template&id=ad0a8616"
import script from "./bigImage.vue?vue&type=script&lang=js"
export * from "./bigImage.vue?vue&type=script&lang=js"
import style0 from "./bigImage.vue?vue&type=style&index=0&id=ad0a8616&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports